export interface CompanyUnreadCounts {
  currentCompanyUnreadCount: number;
  otherCompaniesUnreadCount: number;
}

export const getCompanyUnreadCounts = (
  badgeCounts: Record<number | string, number>,
  currentCompanyId: number
): CompanyUnreadCounts => {
  const currentCompanyUnreadCount = badgeCounts[currentCompanyId] || 0;
  const totalUnreadCount = badgeCounts.ALL || 0;
  const otherCompaniesUnreadCount = Math.max(
    totalUnreadCount - currentCompanyUnreadCount,
    0
  );

  return {
    currentCompanyUnreadCount,
    otherCompaniesUnreadCount,
  };
};
